export class ChannelModel {
    _id: string;
    articleNumber: number;
    name: string;
    description: string;
    system: string;
    corrosionProtection: string;
    crossSection: string;
    stepFile: string;
    material: string;

    constructor(id = '',
        name = '',
        articleNumber = null,
        description = '',
        system = '',
        corrosionProtection = '',
        crossSection = '',
        stepFile = '',
        material = '') {
            this._id = id;
            this.articleNumber = articleNumber;
            this.description = description;
            this.system = system;
            this.corrosionProtection = corrosionProtection;
            this.crossSection = crossSection;
            this.name = name;
            this.stepFile = '';
            this.material = material;
    }
}
